import React, { useEffect, useState } from "react";
import UserAccountIcon from "../../../img/user_account.svg";
import UserAccountSelectedIcon from "../../../img/user_account_selected.svg";
import HistoryIcon from "../../../img/history.svg";
import HistorySelectedIcon from "../../../img/history_selected.svg";
import RoleHistory from "./RoleHistory";
import UserLogs from "./UserLogs";
import useQueryParams from "../../Shared/Hooks/useQueryParms";

const TAB_QUERY_KEY = "tab";

const TAB_QUERY_TO_VALUE = {
  "role-history": "roleHistory",
  "user-log": "userLogs",
};

const TAB_VALUE_TO_QUERY = {
  roleHistory: "role-history",
  userLogs: "user-log",
};

const userActivityTabs = [
  {
    value: "roleHistory",
    label: "Role Change History",
    icon: UserAccountIcon,
    selectedIcon: UserAccountSelectedIcon,
  },
  {
    value: "userLogs",
    label: "User Logs",
    icon: HistoryIcon,
    selectedIcon: HistorySelectedIcon,
  },
];

const UserActivitySection = ({ userId }) => {
  const { params, setParam } = useQueryParams({
    [TAB_QUERY_KEY]: {
      defaultValue: TAB_VALUE_TO_QUERY.roleHistory,
      permittedValues: Object.keys(TAB_QUERY_TO_VALUE),
    },
  });
  const [activeTab, setActiveTab] = useState("roleHistory");

  useEffect(() => {
    const tabQueryValue = params[TAB_QUERY_KEY];
    const mappedTabValue = TAB_QUERY_TO_VALUE[tabQueryValue];

    if (mappedTabValue) {
      if (mappedTabValue !== activeTab) {
        setActiveTab(mappedTabValue);
      }
      return;
    }

    if (activeTab !== "roleHistory") {
      setActiveTab("roleHistory");
    }
  }, [activeTab, params]);

  const handleTabChange = (tabValue) => {
    setActiveTab(tabValue);
    setParam(TAB_QUERY_KEY, TAB_VALUE_TO_QUERY[tabValue]);
  };

  return (
    <section className="user-activity-section">
      <div
        className="activity-tabs"
        role="tablist"
        aria-label="User activity tabs"
      >
        {userActivityTabs.map((tab) => {
          const icon = tab.icon;
          const selectedIcon = tab.selectedIcon;
          const isActive = activeTab === tab.value;

          return (
            <button
              key={tab.value}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`activity-tab ${isActive ? "active" : ""}`}
              onClick={() => handleTabChange(tab.value)}
            >
              <img
                src={isActive ? selectedIcon : icon}
                alt={`${tab.label} Icon`}
                className="activity-tab-icon"
              />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="activity-panel" role="tabpanel">
        {activeTab === "roleHistory" ? (
          <RoleHistory userId={userId} />
        ) : (
          <UserLogs userId={userId} />
        )}
      </div>
    </section>
  );
};

export default UserActivitySection;
